import React from 'react';
import Tooltip from './tooltip';
import TooltipComp from './TooltipComp';
import KrEmojiHover from './../okr/okr_sub_components/kr.emoji.hover';
import { eventKeyConstants } from '../../utils/eventKey'
import { isReadOnlyUserLicenseType } from '../../utils/common';

export const ReactionItem = ({ emoji, addOrRemoveReactionItem, currentUser = {}, mouseOver, mouseLeave, krRowEmojis, emoji_id, changeShowEmojiHoverState, emojiFocusId }) => {
    const userId = (Object.keys(currentUser).length) ? currentUser.id : null;
    const activeClass = emoji.users.find(u => u.id == userId);
    let current_user_des="";
    if(activeClass){
        current_user_des = " Activate button to remove your reaction.";        
    }
    let userName = "";
    if(emoji && Object.keys(emoji).length > 0 && emoji.users){
        emoji.users.forEach(element => {
            userName = userName + ", " + element.name;
        }); 
    }
    const emojiCount = emoji.count || 0;
    if (emojiCount < 1) return null;

    const checkEmoji = (val) =>{
        addOrRemoveReactionItem(emoji, activeClass ? 'remove' : 'add', val, emojiCount == 1 && activeClass ? true : false);
    }
    
    const removeEmoji = (e) => {
        if (e.key === eventKeyConstants.SPACE || e.key === eventKeyConstants.ENTER) {
            e.preventDefault();
            e.stopPropagation();
            checkEmoji(true)
        } else if (e.key === eventKeyConstants.ESCAPE) {
            if (changeShowEmojiHoverState) {
                changeShowEmojiHoverState(false)
                const thumbs_up_icon = document.getElementById(emojiFocusId);
                if (thumbs_up_icon) thumbs_up_icon.focus()
            }
        } else if (e.key === eventKeyConstants.TAB && !e.shiftKey) {
            if (changeShowEmojiHoverState) {
                e.preventDefault()

                if (e.target.parentElement.nextSibling === null) {
                    const el = `#reaction-combined-shape #${emoji_id}`
                    const focusEl = $(el)
                    if(focusEl) focusEl.focus()
                } else {
                    e.target.parentElement.nextSibling.children[0].focus()
                }
            }
        }
    }
    return (
        <Tooltip
            emoji={emoji}
            krRowEmojis={krRowEmojis}
        >
            <div id={`emoji-${emoji.id}-${emoji_id}`}
                tabIndex={0} role="button"
                aria-label={`${emoji.name} ${emojiCount} from ${userName}. ${current_user_des}`}               
                className={'reacted-emoji-icon ' + (activeClass ? ' active ' : '')}
                style={{
                    cursor: 'pointer',
                    display: krRowEmojis ? 'flex' : ''
                }}
                onClick={!isReadOnlyUserLicenseType() ? () => checkEmoji(false) : '' }
                onKeyDown={ !isReadOnlyUserLicenseType() ? (e) => {  removeEmoji(e) } : ''}
            >
                <span className='emoji-icon'>
                    <img src={emoji.filepath} alt={emoji.name} className='emoji-icon-img' />
                </span>
                <span className='emoji-count' style={{ paddingTop: krRowEmojis ? '3px' : '' }}>
                    {emoji.count}
                </span>
            </div>
        </Tooltip>
    );
}

export const ReactionControlList =  (props) => {
    const {
        emojis = [], toggleReactionEmojis, addReactionItem, addOrRemoveReactionItem,
        currentUser = {}, krRowEmojis, metric, emojisData, reacted_emojis, goalId,
        parentMetricId, emoji_id, changeShowEmojiHoverState, emojiFocusId, id_of_emoji
    } = props;
    let show_reacted_emoji = true;
    let width,left;
    if(metric) {
        width = (30 + (metric.emoji_count * 58)) + "px";
        left = "-" + ((metric.emoji_count*30)-2) + "px";
    }
    const isTabbingControl = () => {
        const isTabbing = document.body.classList.contains('is-tabbing');
        if (!isTabbing) {
            document.body.classList.add('is-tabbing');
        }
    }

    const emojiTooltipKeyboardHandler = (e, emoji) => {
        const refElem = e.target.closest('#reaction-combined-shape');
        const focusableElements = refElem.querySelectorAll(
            '[role="menuitem"]'
        )
        const focusableRowArr = Array.prototype.slice.call(focusableElements);
        const focusRowIndex = focusableRowArr?.indexOf(e.target);

        switch (e.key) {
            case eventKeyConstants.ARROWUP:
            case eventKeyConstants.ARROWLEFT:
                e.preventDefault();
                isTabbingControl();
                if (focusRowIndex === 0) {
                    focusableRowArr[focusableRowArr.length - 1]?.focus();
                } else {
                    focusableRowArr[focusRowIndex - 1]?.focus();
                }
                break;
            case eventKeyConstants.ARROWDOWN:
            case eventKeyConstants.ARROWRIGHT:
                e.preventDefault();
                isTabbingControl();
                if (focusRowIndex === focusableRowArr.length - 1) {
                    focusableRowArr[0]?.focus();
                } else {
                    focusableRowArr[focusRowIndex + 1]?.focus();
                }
                break;
            case eventKeyConstants.SPACE:
            case eventKeyConstants.ENTER:
                e.preventDefault();
                setTimeout(() => {
                    document.getElementById(emoji_id)?.focus();
                    document.getElementById(id_of_emoji)?.focus();
                });
                addReactionItem(emoji);
                break;
            case eventKeyConstants.ESCAPE:
                e.preventDefault();
                e.stopPropagation();
                document.getElementById(emoji_id)?.focus();
                toggleReactionEmojis(e);
                isTabbingControl();
                break;
            case eventKeyConstants.TAB:
                e.preventDefault();
                document.getElementById(emoji_id)?.focus();
                toggleReactionEmojis('onLeave');
                isTabbingControl();
                break;
            default:
                break;
        }
    }

    return (
        <ul
            className='reaction-combined-shape'
            role="menu"
            tabIndex={-1}
            id="reaction-combined-shape"
            style={krRowEmojis ? {
                minWidth: "fit-content",
                top: "-55px",
                width: metric && metric.emoji_count==0 ? "40px" : width,
                left: metric && metric.emoji_count==0 ? "-8px" : left
            } : {}}>
            {
                krRowEmojis &&
                    <KrEmojiHover
                        metric={metric}
                        emojisData={emojisData}
                        showReactedEmoji={false}
                        showReaction = {true}
                        goalId={goalId}
						parentMetricId={parentMetricId}
                        emoji_id={emoji_id}
                        changeShowEmojiHoverState={changeShowEmojiHoverState}
                        emojiFocusId={emojiFocusId}
                    />
            }
            {
                krRowEmojis ?
                    <>{
                        show_reacted_emoji && reacted_emojis.length?
                            <div className='reacted-emoji-wrapper' style={{
                                padding: '8px 0',
                                display: 'flex'
                            }} id = 'reacted-emoji-wrapper'>
                                {
                                    reacted_emojis.map((emoji, index) => {
                                        return <ReactionItem 
                                                key={'memozied_react_' + index} 
                                                emoji={emoji} 
                                                krRowEmojis={krRowEmojis} 
                                                addOrRemoveReactionItem={addOrRemoveReactionItem}
                                                currentUser={currentUser}
                                                emoji_id={emoji_id}
                                                changeShowEmojiHoverState={changeShowEmojiHoverState}
                                                reactedEmojis={reacted_emojis}
                                                emojiFocusId={emojiFocusId}/>;
                                    })
                                }
                            </div>
                            : ''
                    }</> :
                    emojis.map((emoji, index) => (
                        <TooltipComp
                            content={emoji.name}
                            key={`reaction_emjoi_${emoji.id}`}
                            rightEdgeEltooltip={index === emojis.length - 1}
                        >
                            <li
                                tabIndex={-1}
                                aria-label={emoji.name}
                                role="menuitem"
                                className="reaction-emoji-icon"
                                data-content={`emoji-${emoji.id}`}
                                onClick={() => addReactionItem(emoji)}
                                onKeyDown={e => emojiTooltipKeyboardHandler(e, emoji)}
                            >
                                <img src={emoji.filepath} alt={emoji.name} className='reaction-emojis-icon-img' />
                            </li>
                        </TooltipComp>
                    ))
            }
        </ul>
    );
}